export default "__VITE_ASSET__DVs2wh_3__"